import DragCoordinatorService from 'ember-drag-drop/services/drag-coordinator';

export default DragCoordinatorService;